import React from 'react';
import { Table, Button } from 'antd';
import './FreeAgentsTable.css'; // Import the custom CSS

const RosterTable = ({ rosterPlayers, onDrop, filterLeague, filterPosition, filterTeam, filterDepthChart }) => {
  const columns = [
    {
      title: 'Player',
      dataIndex: 'playerName',
      key: 'name',
      width: 160,
      fixed: 'left',
      sorter: (a, b) => (a.playerName || '').localeCompare(b.playerName || ''),
    },
    {
      title: 'Team',
      dataIndex: 'team',
      key: 'team',
      width: 70,
      sorter: (a, b) => (a.team || '').localeCompare(b.team || ''),
    },
    {
      title: 'Pos',
      dataIndex: 'position',
      key: 'position',
      width: 60,
      sorter: (a, b) => (a.position || '').localeCompare(b.position || ''),
    },
    {
      title: 'Depth',
      dataIndex: 'depthChart',
      key: 'depthChart',
      width: 70,
      sorter: (a, b) => (a.depthChart||'').localeCompare(b.depthChart||''),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 70,
      sorter: (a, b) => (a.status || '').localeCompare(b.status || ''),
    },
    { 
      title: 'Add %', 
      dataIndex: 'addPercentage', 
      key: 'addPercentage',
      width: 80,
      render: (value) => value != null ? `${value.toFixed(1)}%` : '-', // Check for null/undefined
      sorter: (a, b) => parseFloat(a.addPercentage||0) - parseFloat(b.addPercentage||0), // Numeric sorting
    },
    { 
      title: 'Own %', 
      dataIndex: 'ownPercentage', 
      key: 'ownPercentage',
      width: 80,
      render: (value) => value != null ? `${value.toFixed(1)}%` : '-', // Check for null/undefined
      sorter: (a, b) => parseFloat(a.ownPercentage||0) - parseFloat(b.ownPercentage||0), // Numeric sorting
    },
    { 
      title: 'Drop %', 
      dataIndex: 'dropPercentage', 
      key: 'dropPercentage',
      width: 80,
      render: (value) => value != null ? `${value.toFixed(1)}%` : '-',
      sorter: (a, b) => parseFloat(a.dropPercentage||0) - parseFloat(b.dropPercentage||0),
    },
    { 
      title: 'Route %', 
      dataIndex: 'routeParticipation', 
      key: 'routeParticipation',
      width: 80,
      render: (value) => value != null ? `${value.toFixed(1)}%` : '-', // Check for null/undefined
      sorter: (a, b) => parseFloat(a.routeParticipation||0) - parseFloat(b.routeParticipation||0), // Numeric sorting
    },
    { 
      title: 'TPRR', 
      dataIndex: 'targetsPerRouteRun', 
      key: 'targetsPerRouteRun',
      width: 80,
      render: (value) => value != null ? `${value.toFixed(1)}%` : '-', // Check for null/undefined
      sorter: (a, b) => parseFloat(a.targetsPerRouteRun||0) - parseFloat(b.targetsPerRouteRun||0), // Numeric sorting
    },
    { 
      title: 'Carry Share', 
      dataIndex: 'carryShare', 
      key: 'carryShare',
      width: 90,
      render: (value) => value != null ? `${value.toFixed(1)}%` : '-', // Check for null/undefined
      sorter: (a, b) => parseFloat(a.carryShare||0) - parseFloat(b.carryShare||0), // Numeric sorting
    },
    {
      title: 'Action',
      key: 'action',
      width: 80,
      fixed: 'right',
      render: (text, record) => (
        <Button size="small" onClick={() => onDrop(record.playerID, record.leagueID)}>
          Drop
        </Button>
      )
    }
  ];

  const filteredData = rosterPlayers.filter((rp) =>
    (!filterLeague || String(rp.leagueID) === String(filterLeague)) &&
    (!filterPosition || rp.position === filterPosition) &&
    (!filterTeam || rp.team === filterTeam) &&
    (!filterDepthChart || rp.depthChart === filterDepthChart)
  );

  return <Table 
    columns={columns}
      dataSource={filteredData}
      rowKey={(record) => `${record.playerID}-${record.leagueID}`}
      pagination={{ pageSize: 100 }}  // Show 100 rows per page
      size="small"
      bordered
      scroll={{ x: 820, y: 500 }}
      className="custom-table"  // Apply custom class for styling
  />;
};

export default RosterTable;
